<template>
    <div class="container-fluid mb-4">

        <div class="row life-event-header pl-3">
            <div class="col-12 font-weight-bold life-event-header-title">
                あなたのライフイベント
            </div>
        </div>
        <div class="row life-event-area" id="eventToggle">
            <div class="col p-3 d-flex justify-content-center">
                <ul class="w-xs-100 w-50">
                    <li v-for="(ev, index) in lifeEventList" :key="index">
                        <img class="eventFaceImg" v-if="ev.event.indexOf('誕生') !== -1" src="@/assets/img/result/event/200-baby.png" alt="">
                        <img class="eventFaceImg" v-if="ev.event.indexOf('卒業') !== -1" src="@/assets/img/result/event/200_5.png" alt="">
                        <img class="eventFaceImg" v-if="ev.event.indexOf('定年退職') !== -1" src="@/assets/img/result/event/200_7.png" alt="">
                        <img class="eventFaceImg" v-if="ev.event.indexOf('ローン完済') !== -1" src="@/assets/img/result/event/200_8.png" alt="">
                        <span class="event-age">{{ev.age}}</span><span>{{ ev.event }}</span>
                    </li>
                </ul>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    name: "LifeEvent.vue",
    props: [
        'calc',
        'lifeEventList',
    ],
    data() {
        return {
        }
    },
    computed: {
        fufuText() {
            if (this.$store.state.haiguusha.ari) {
                return 'ご夫婦';
            }
            else {
                return '世帯主';
            }
        },
        okosamaNumber() {
            if (this.calc.okosamaNumber()>0) {
                return 'お子さま '+this.calc.okosamaNumber()+'人';
            }
            return '';
        }
    }
}
</script>

<style scoped lang="scss" >

.life-event-header{
    background: linear-gradient(180deg,#fcf150,#fefcde)!important;
    height: 40px;

    .life-event-header-title {
        color: #000;
        font-size: 18px;
        text-decoration: none;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
}

.life-event-area {
    background-color: #FEFCDE;

    .eventFamilyArea{
        padding-bottom: 0;

        p{
            margin: 0;
        }
        .eventFamilyContent{
            margin:0 auto;

            .eventFamilyImg{
                width:100px;
            }

            &.sp {
                .eventFamilyImg {
                    vertical-align: bottom;
                }
                .sp-text {
                    display: inline-block;
                    margin-left: 15px;
                    margin-bottom: 10px;
                }
            }

        }
    }
    ul {
        list-style:none;
        padding-left: 0;

        li {
            background-color: #FFFFFF;
            border: #D9ECFA 2px solid;
            border-radius: 40px;
            padding: 10px 20px 10px 20px;
            margin-bottom: 10px;

            .eventFaceImg{
                //position: absolute;
                width: 30px;
                margin-top: -3px;
            }

            .event-age {
                margin-left: 40px;
                margin-right: 15px;
            }
        }
    }
}

@media screen and (max-width: 576px) {

    .eventFamilyContent.sp {
        display: block !important;
    }
    .eventFamilyContent.pc {
        display: none !important;
    }
    .w-xs-100 {
      width: 100%!important;
    }

}


</style>